const hasControlCharacters = (value: string): boolean =>
  Array.from(value).some((character) => {
    const code = character.charCodeAt(0);
    return code < 32 || code === 127;
  });

export function isHttpUrl(value: string): boolean {
  if (!/^https?:\/\//i.test(value) || hasControlCharacters(value) ||
      value.includes(" ") || value.includes("\\")) {
    return false;
  }
  try {
    const url = new URL(value);
    return (url.protocol === "https:" || url.protocol === "http:") &&
      !url.username && !url.password;
  } catch {
    return false;
  }
}

export function isInternalDestination(value: string): boolean {
  if (!value || value !== value.trim() || hasControlCharacters(value) || value.includes("\\")) {
    return false;
  }
  const path = value.split(/[?#]/, 1)[0];
  if (/^[a-z][a-z0-9+.-]*:/i.test(path) || path.startsWith("//")) return false;
  // Encoded separators can change how a path is interpreted after decoding.
  if (/%(?:2f|5c|0[0-9a-f]|1[0-9a-f]|7f|25)/i.test(path)) return false;
  try {
    return new URL(value, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
}
